export default __webpack_public_path__ + "static/media/medial_b.40444b85.jpg";